export default __webpack_public_path__ + "fonts/designer.b765d5b5a58a422e977fc297d73cb1a8.png";